import { type PropsWithChildren } from 'react';

type Props = {
  className?: string;
};

const TBody: React.FC<PropsWithChildren<Props>> = ({ children, className }) => (
  <tbody className={className}>{children}</tbody>
);

export default TBody;
